import { render, staticRenderFns } from "./CreateDnsRecord.vue?vue&type=template&id=75f03333&"
import script from "./CreateDnsRecord.vue?vue&type=script&lang=ts&"
export * from "./CreateDnsRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports